import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Loading from '../../components/Loader'
import Footer from '../../components/footer'
import '../../assets/sass/views/Tutorial.scss'
import { useTranslation } from 'react-i18next'

// Importer les images correctement
import Q3 from '../../assets/images/Q3-img.png'
import Q5 from '../../assets/images/Q5-img.png'

const Help = () => {
  const { t } = useTranslation('global')
  const [loading, setLoading] = useState({ status: true })
  useEffect(() => {
    setTimeout(() => {
      setLoading({ status: false })
    }, 500)
  }, [])

  const faq = [
    {
      id: 1,
      question: 'q1',
      content: [
        { type: 'text', key: 'r1one' },
        { type: 'text', key: 'r1two' },
        { type: 'text', key: 'r1thre' }
      ]
    },
    {
      id: 2,
      question: 'q2',
      content: [
        { type: 'text', key: 'r2' }
      ]
    },
    {
      id: 3,
      question: 'q3',
      content: [
        { type: 'text', key: 'r3one' },
        { type: 'text', key: 'r3two' },
        { type: 'image', src: Q3, alt: 'Illustration Q3' } // Corrigé ici
      ]
    },
    {
      id: 4,
      question: 'q4',
      content: [
        { type: 'text', key: 'r4' }
      ]
    },
    {
      id: 5,
      question: 'q5',
      content: [
        { type: 'text', key: 'r5one' },
        { type: 'text', key: 'r5two' },
        { type: 'text', key: 'r5thre' },
        { type: 'text', key: 'r5four' },
        { type: 'text', key: 'r5five' },
        { type: 'image', src: Q5, alt: 'Illustration Q5' } // Corrigé ici
      ]
    },
    {
      id: 6,
      question: 'q6',
      content: [
        { type: 'text', key: 'r6one' },
        { type: 'text', key: 'r6two' }
      ]
    },
    {
      id: 7,
      question: 'q7',
      content: [
        { type: 'text', key: 'r7' }
      ]
    },
    {
      id: 8,
      question: 'q8',
      content: [
        { type: 'text', key: 'r8' }
      ]
    },
    {
      id: 9,
      question: 'q9',
      content: [
        { type: 'text', key: 'r9' }
      ]
    },
    {
      id: 10,
      question: 'q10',
      content: [
        { type: 'text', key: 'r10' }
      ]
    },
    {
      id: 11,
      question: 'q11',
      content: [
        { type: 'text', key: 'r11one' },
        { type: 'text', key: 'r11two' }
      ]
    },
    {
      id: 12,
      question: 'q12',
      content: [
        { type: 'text', key: 'r12one' },
        { type: 'text', key: 'r12two' },
        { type: 'text', key: 'r12thre' },
        { type: 'text', key: 'r12four' },
        { type: 'text', key: 'r12five' }
      ]
    },
    {
      id: 13,
      question: 'q13',
      content: [
        { type: 'text', key: 'r13' }
      ]
    },
    {
      id: 14,
      question: 'q14',
      content: [
        { type: 'text', key: 'r14one' },
        { type: 'text', key: 'r14two' },
        { type: 'text', key: 'r14thre' },
        { type: 'text', key: 'r14four' }
      ]
    },
    {
      id: 15,
      question: 'q15',
      content: [
        { type: 'text', key: 'r15one' },
        { type: 'text', key: 'r15two' },
        { type: 'text', key: 'r15thre' },
        { type: 'text', key: 'r15four' },
        { type: 'text', key: 'r15five' },
        { type: 'text', key: 'r15six' },
        { type: 'text', key: 'r15seven' },
        { type: 'text', key: 'r15eight' },
        { type: 'text', key: 'r15nine' },
        { type: 'text', key: 'r15ten' },
        { type: 'text', key: 'r15eleven' },
        { type: 'text', key: 'r15twelve' }
      ]
    }
  ]

  return (
    <>
      {loading.status ? <Loading addClass={'active'} /> : ''}
      <Header activeTab={4} />
      <div className='help'>
        <div className='presentation'>
          <h1>{t('views.help.title')}</h1>
          <p>{t('views.help.illustration')}</p>
        </div>
        <div className="accordeon">
          {faq.map(({ id, question, content }) => (
            <div key={id}>
              <input type="radio" id={id} name="liste" />
              <label htmlFor={id}>
                <div>{t(`views.help.${question}`)}</div>
                <div className="cross"></div>
              </label>
              <div className="content">
                {content.map((item, index) => {
                  if (item.type === 'text') {
                    return <p key={index}>{t(`views.help.${item.key}`)}</p>
                  }
                  if (item.type === 'image') {
                    return <div key={index}><img src={item.src} alt={item.alt || ''} /></div>
                  }
                  return null
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer isVisibleBall={false} />
    </>
  )
}

export default Help
